import { tracker } from '@ixigo/analytics';
import { LoginComponent, type LoginConfig } from '@ixigo-packages/login';
import type { AppContext } from '@/utils/headers';
import { useAppContext } from './useAppContext';

const loginConstants = {
	recaptchaToken: '6LcyoLcUAAAAAIawkLXQYgj61-aAhBT8HphqYI6Q',
	googleClientId:
		'609822318055-7gifp26me07tnaphkgu3ilf51hjusat6.apps.googleusercontent.com',
	resendTimer: 60,
};

export const getLoginConfig = (context: AppContext) => {
	const { recaptchaToken, resendTimer, googleClientId } = loginConstants;

	const clientConfig = context.clientConfig();
	const config: LoginConfig = {
		apiKey: clientConfig.apiKey,
		clientId: clientConfig.clientId,
		recaptchaToken,
		// TODO: fix this type issue in "@ixigo-packafes/login"
		cookie: context.cookie as LoginConfig['cookie'],
		localStorage:
			typeof window !== 'undefined' ? window.localStorage : undefined,
		resendTimer,
		googleClientId,
		autoGoogleLogin: true,
		trackEvent: tracker.track,

		// TODO: fix this type issue in "@ixigo-packafes/analytics"
		product: 'CAB',
		identifyCTLoggedInUser: tracker.identifyLoggedInUser,
		otplessEnabled: true,
	};
	return config;
};

export function LoginProvider({ children }: { children: React.ReactNode }) {
	const context = useAppContext();
	if (!context) return children;
	return (
		<LoginComponent config={getLoginConfig(context)}>{children}</LoginComponent>
	);
}
